<template>
    <td-dialog :title="$t(title)" :before-close="logLevelDialogClose" :visible.sync="dialogLevelVisible" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formLogInfo" :label-width="formLabelWidth" ref="formLogInfo" :rules="rules">
            <el-form-item :label="$t('common.NUMBER')" prop="sId" v-if="false">
                <el-col :span="16">
                    <td-input-number v-model="formLogInfo.sId" :disabled="autoIdDisabled" :controlsPosition="controlsPosition"></td-input-number>
                </el-col>
                <el-col :span="2">
                    <td-checkbox v-model="sIdChecked" ref="sIdChecked" v-if="isAddData" @change="autoCreateId" name="common.AUTO_CREATE"></td-checkbox>
                </el-col>
            </el-form-item>
            <el-form-item :label="$t('common.NAME')" prop="sCaption">
                <td-input v-model="formLogInfo.sCaption" :maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescription">
                <td-input type="textarea" :rows="2" style="width:200px;" v-model="formLogInfo.sDescription" :maxlength="100"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formLogInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="logLevelDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import levelApi from '../assets/api.js';
export default {
    props: ['title', 'dialogLevelVisible', 'editItem', 'isAddData', 'sSysFlg'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
    },
    // 定义变量
    data() {
        let validateCaption = (rule, value, callback) => {
            let param = {
                sCaption: value,
                sSysFlg: this.sSysFlg
            };
            let _this = this;
            levelApi.checkOperationLevel(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('type/checkOperationLevel', response.data.statusMessage);
                    return;
                }
                if (response.data.content) {
                    let check = response.data.content.some(function(item) {
                        if (item.sId != _this.formLogInfo.sId) {
                            return true;
                        }
                    });
                    if ((!this.isAddData && check) || this.isAddData) {
                        callback(this.$t('error.ERROR_OPE_LEVEL_REPEAT'));
                    }
                }
                return callback();
            });
        };
        return {
            // 表单信息
            formLogInfo: {
                sId: '',
                sCaption: '',
                sDescription: ''
            },
            controlsPosition: 'right',
            sIdChecked: true,
            autoIdDisabled: true,
            formLabelWidth: '100px',
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sCaption: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_NAME_MAX_LENGTH'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { validator: validateCaption, trigger: 'blur' }
                ],
                sDescription: [{ min: 1, max: 100, message: this.$t('error.ERROR_DESCRIPTION_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formLogInfo.sId = this.editItem.sId;
            this.formLogInfo.sCaption = this.editItem.sCaption;
            this.formLogInfo.sDescription = this.editItem.sDescribe;
        },
        // 提交数据
        submitForm(formName) {
            let _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.loading = true;
                    let content = {
                        sId: _this.formLogInfo.sId,
                        sCaption: _this.formLogInfo.sCaption,
                        sDescribe: _this.formLogInfo.sDescription,
                        sSysFlg: _this.sSysFlg
                    };
                    if (_this.isAddData) {
                        levelApi.addOperationLevel(JSON.stringify(content), response => {
                            _this.loading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                _this.$log.error('dialogLevelInfo/addOperationLevel', response);
                                return;
                            }
                            _this.$message({ showClose: true, message: _this.$t('common.ADD_SUCCESS'), type: 'success' });
                            _this.logLevelDialogSave();
                        });
                    } else {
                        content.sid = _this.editItem.sId;
                        levelApi.updateOperationLevel(JSON.stringify(content), response => {
                            _this.loading = false;
                            if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                _this.$log.error('dialogLevelInfo/updateOperationLevel', response);
                                return;
                            }
							_this.$message({ showClose: true, message: _this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            _this.logLevelDialogSave();
                        });
                    }
                }
            });
        },

        // 自动生成id
        autoCreateId() {
            if (!this.isAddData) {
                this.autoIdDisabled = true;
                return;
            }
            if (this.autoIdDisabled) {
                this.autoIdDisabled = false;
            } else {
                this.formLogInfo.sId = null;
                this.autoIdDisabled = true;
            }
        },

        // 关闭窗口之前需要调用的方法
        logLevelDialogClose() {
            this.$emit('logLevelDialogClose');
        },
        logLevelDialogSave() {
            this.$emit('logLevelDialogClose');
            this.$emit('submit');
            this.$refs['formLogInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
